import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import DisplayForcedNotifications from 'widgets/forced-notifications/DisplayForcedNotifications'
import { OnNavigatePipeline, useOnNavigate, useRouter } from '@morningtrain/react-navigation'
import RefreshForcedNotificationsOnPipe from 'widgets/forced-notifications/partials/RefreshForcedNotificationsOnPipe'

export default function ForcedNotificationsService ({ children }) {
  const [forcedNotifications] = useEnvValue('forced_notifications', {})
  const [isTablet] = useEnvValue('device.is_authorized')
  const router = useRouter()
  const [user] = useEnvValue('user', null)

  const checkIfIsResolvingNotification = React.useCallback(() => {
    if (forcedNotifications.checklists && forcedNotifications.checklists.length > 0) {
      if (router.currentRoute === 'app.checklists' || router.currentRoute === 'app.view_checklist') {
        return true
      }
    }

    return false
  }, [forcedNotifications, router])

  const [resolvingNotification, setResolvingNotification] = React.useState(checkIfIsResolvingNotification())

  const shouldDisplay = React.useMemo(() => {
    return !isTablet || (forcedNotifications && forcedNotifications.count === 0) || resolvingNotification || user === null
  }, [isTablet, forcedNotifications, resolvingNotification])

  useOnNavigate(() => {
    const isResolving = checkIfIsResolvingNotification()
    if (isResolving !== resolvingNotification) {
      setResolvingNotification(isResolving)
    }
  }, [resolvingNotification, checkIfIsResolvingNotification])

  if (shouldDisplay) {
    return (
      <>
        <OnNavigatePipeline>
          <RefreshForcedNotificationsOnPipe />
        </OnNavigatePipeline>
        {children}
      </>
    )
  }

  return <DisplayForcedNotifications />
}
